import { IconProps, iconA11yProps } from '../types';

export const SwitchAccount = ({ classNames, label }: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={classNames}
        {...iconA11yProps(label)}
    >
        <path d="M3 17h2.397a5 5 0 0 0 4.096 -2.133l.177 -.253m3.66 -5.227l.177 -.254a5 5 0 0 1 4.096 -2.133h3.397" />
        <path d="M18 4l3 3l-3 3" />
        <path d="M3 7h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397" />
        <path d="M18 20l3 -3l-3 -3" />
    </svg>
);
